// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__rXIa3","header":"MessagesList_header__2XxIF","chat":"MessagesList_chat__2TKeY"};